let modal_controller = null;
let modal_promise = null;

export function register_session_modal(controller) {
  modal_controller = controller;
}

export function unregister_session_modal(controller) {
  if (modal_controller === controller) {
    modal_controller = null;
  }
}

export function show_modal_error(message) {
  modal_controller?.show_error(message);
}

export function open_session_modal(on_missing_bootstrap, options = {}) {
  if (modal_promise) {
    return modal_promise;
  }

  if (!modal_controller) {
    on_missing_bootstrap();
    return Promise.resolve('logout');
  }

  modal_promise = modal_controller.open(options).finally(() => {
    modal_promise = null;
  });
  return modal_promise;
}

export function close_session_modal() {
  modal_controller?.close();
}
